<template>
  <k-label v-if="$permissions.hasPermission('view_external_data_source_labels')" :label="label"/>
</template>

<script>
import KLabel from './k-label.vue';

export default {
  components: { KLabel },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
